/**
 * Diagram node mutation: process multiple nodes, edit from activity, change node data, process candidate.
 * Uses window.myDiagram, DrawOrgCharts, sessionStorage, showNoCreditsModal, showPersonNotFoundModal, addNewNode.
 */
import { showNoCreditsModal, showPersonNotFoundModal } from './diagram-modals.js';
import { addNewNode } from './diagram-blocks.js';

function compute_credits() {
  return 500;
}

function processMultipleNodes(data, response_nodes, org_data) {
  if (!window.myDiagram) return;
  if (response_nodes.length === 0) {
    showPersonNotFoundModal();
    return;
  }

  const allNodes = [];
  window.myDiagram.nodes.each(function (n) {
    allNodes.push(n.data);
  });

  let uncommon_nodes = [];
  let common_nodes = [];
  const common_nodes_array = [];
  for (let i = 0; i < allNodes.length; i++) {
    for (let j = 0; j < response_nodes.length; j++) {
      if (allNodes[i].std_function === response_nodes[j].std_function && allNodes[i].std_grade === response_nodes[j].std_grade) {
        common_nodes_array.push({ response_node_data: response_nodes[j], node_key: allNodes[i].key });
        common_nodes.push(response_nodes[j]);
      }
    }
  }

  const a = response_nodes;
  const b = common_nodes;
  const isSameUser = (x, y) => x.std_function === y.std_function && x.std_grade === y.std_grade;
  const onlyInLeft = (left, right, compareFn) => left.filter(lv => !right.some(rv => compareFn(lv, rv)));
  const onlyInA = onlyInLeft(a, b, isSameUser);
  const onlyInB = onlyInLeft(b, a, isSameUser);
  uncommon_nodes = [...onlyInA, ...onlyInB];

  for (let i = 0; i < uncommon_nodes.length; i++) {
    updateMultipleNodesOrgChartDataFunctGrade(uncommon_nodes[i], 'uncommon_nodes', org_data, 'uncommon_nodes');
  }
  for (let i = 0; i < common_nodes_array.length; i++) {
    updateMultipleNodesOrgChartDataFunctGrade(common_nodes[i], 'common_nodes', org_data, 'common_nodes');
  }
}

function editNodesFromPreviousActivity(response_params) {
  if (typeof response_params['past_data'] === 'undefined' || response_params['past_data'].length === 0) return;
  const prior = response_params.prior_query_id_key;
  if (!prior) return;
  for (let i = 0; i < prior.length; i++) {
    const key_number = prior[i].key;
    const parent = prior[i].parent;
    const queryId = prior[i].queryId;
    const selected_people = response_params.past_data.filter(function (p) { return p['queryId'] === queryId; });
    const node_data_obj = { data: selected_people, status: 'success' };
    changeNodeDataUsingQueryResponse(node_data_obj, key_number, parent);
  }
}

function updateMultipleNodesOrgChartDataFunctGrade(data, node_modification_type, org_data, update_node_type) {
  if (!window.myDiagram || !data['candidates'] || data['candidates'].length === 0) return;
  const updated_org_node_data = new DrawOrgCharts().getOrgChartNodeJsonObjWithoutKeyParent(data);

  if (node_modification_type === 'uncommon_nodes') {
    if (typeof org_data === 'object') {
      if (updated_org_node_data['std_function_root'] === org_data['type']) {
        updated_org_node_data['parent'] = 1;
        updated_org_node_data['key'] = Math.floor(Math.random() * 100000) + 100000;
        addNewNode(updated_org_node_data);
      } else {
        addNewNode(updated_org_node_data);
      }
    } else {
      updated_org_node_data['parent'] = 1;
      updated_org_node_data['key'] = Math.floor(Math.random() * 100000) + 100000;
      addNewNode(updated_org_node_data);
    }
  } else {
    const thisemp = window.myDiagram.findNodesByExample({ std_function: data['std_function'], std_grade: data['std_grade'] }).first();
    if (!thisemp) return;
    for (const x in updated_org_node_data) {
      if (x !== 'key' && x !== 'parent') {
        window.myDiagram.model.setDataProperty(thisemp.data, x, updated_org_node_data[x]);
      }
    }
  }
}

function changeNodeDataUsingQueryResponse(data, node_key, parent) {
  if (!window.myDiagram) return;
  if (data['query_status'] === 'logged_out') {
    window.location.href = '/login';
    return;
  }
  if (data['query_status'] === 'no_credits') {
    showNoCreditsModal();
    return;
  }
  if (data['status'] !== 'success') {
    showPersonNotFoundModal();
    return;
  }
  sessionStorage['people_data'] = JSON.stringify(data);
  data['candidates'] = data['results']['data']['modified_query_results'];
  const updated_org_node_data = new DrawOrgCharts().getOrgChartNodeJsonObj(data, node_key, parent);
  const thisemp = window.myDiagram.findNodesByExample({ std_function: data['std_function'], std_grade: data['std_grade'] }).first();
  if (!thisemp || thisemp.category === 'detailed') return;
  for (const x in updated_org_node_data) {
    window.myDiagram.model.setDataProperty(thisemp, x, updated_org_node_data[x]);
  }
}

function processCandidate(candidate, array_obj, i) {
  if (Object.keys(array_obj).includes('shorten') && array_obj['shorten'] === 'no') {
    array_obj['category'] = 'detailed';
  }
  array_obj['title_' + i] = (candidate['job_title'] != null) ? candidate['job_title'] : 0;
  array_obj['name_' + i] = (candidate['full_name'] != null) ? candidate['full_name'] : 0;
  array_obj['std_salary_ctc_' + i] = (candidate['std_salary_ctc'] != null) ? candidate['std_salary_ctc'] : 0;
  array_obj['location_' + i] = (candidate['location'] != null) ? candidate['location'] : 0;
  array_obj['image_' + i] = (candidate['image'] != null) ? candidate['image'] : 0;
  array_obj['gender_' + i] = (candidate['gender'] != null) ? candidate['gender'] : 0;
  array_obj['id_' + i] = (candidate['id'] != null && candidate['id'] !== '') ? candidate['id'] : i.toString();
  array_obj['linkedin_url_' + i] = (candidate['std_linkedin_url'] != null) ? candidate['std_linkedin_url'] : 0;
  array_obj['facebook_url_' + i] = (candidate['facebook_url'] != null) ? candidate['facebook_url'] : 0;
  array_obj['total_people'] = array_obj['candidates'].length;

  if (array_obj['total_people'] === 0 || array_obj['len_candidates'] === '' || (candidate['len_candidates'] === '')) {
    array_obj['height_0'] = array_obj['height_1'] = array_obj['height_2'] = array_obj['height_3'] = 0;
  } else if (array_obj['total_people'] === 1) {
    array_obj['height_1'] = array_obj['height_2'] = array_obj['height_3'] = 0;
  } else if (array_obj['total_people'] === 2) {
    array_obj['height_2'] = array_obj['height_3'] = 0;
  } else if (array_obj['total_people'] === 3) {
    array_obj['height_3'] = 0;
  }
  if (array_obj['isAssistant'] === '0') delete array_obj.isAssistant;
  if (array_obj['category'] === '0') delete array_obj.category;
  return [array_obj, candidate];
}

export {
  compute_credits,
  processMultipleNodes,
  editNodesFromPreviousActivity,
  updateMultipleNodesOrgChartDataFunctGrade,
  changeNodeDataUsingQueryResponse,
  processCandidate
};
